/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import Total4WMarketPage from 'src/pages/ReportsPages/ReportsBoard/4wPages/Total4WMarketPage'
import boardReportsService from 'src/services/boardReportsService'

const Total4WMarketContainer = () => {
  const [total, setTotals] = useState([])
  const [totalCommercial, setTotalsCommercial] = useState([])

  const [selectedDate, setSelectedDate] = useState(new Date())

  const [totalCategory, setTotalCategory] = useState([])
  const [totalCompany, setTotalCompany] = useState([])
  const [gATotalCompany, setGATotalCompany] = useState([])
  const [gBTotalCompany, setGBTotalCompany] = useState([])
  const [gTotal, setGTotal] = useState([])
  const [gACategory, setGACategory] = useState([])
  const [gBCategory, setGBCategory] = useState([])
  const [totalCommercial5, setTotalsCommercial5] = useState([])
  const [totalCommercial6, setTotalsCommercial6] = useState([])
  const [totalCommercial4A, setTotalsCommercial4A] = useState([])
  const [totalCommercial4B, setTotalsCommercial4B] = useState([])
  const [totalCommercial5GB, setTotalsCommercial5GB] = useState([])
  const [totalCommercial6A, setTotalsCommercial6A] = useState([])
  const [totalCommercial6B, setTotalsCommercial6B] = useState([])
  const [total4P, setTotal4P] = useState([])
  const [total5P, setTotal5P] = useState([])
  const [total6P, setTotal6P] = useState([])
  const [gTotal4AP, setTotalG4AP] = useState([])
  const [gTotal4BP, setTotalG4BP] = useState([])
  const [gTotal5P, setGTotal5P] = useState([])
  const [gTOTAL6AP, setGTotal6AP] = useState([])
  const [gTOTAL6BP, setGTotal6BP] = useState([])
  const [total7CL, setTotal7CL] = useState([])
  const [total8CL, setTotal8CL] = useState([])
  const [total9CL, setTotal9CL] = useState([])
  const [gTotal7ACL, setGTotal7ACL] = useState([])
  const [gTotal7BCL, setGTotal7BCL] = useState([])
  const [gTotal8CL, setGTotal8CL] = useState([])
  const [gTotal9ACL, setGTotal9ACL] = useState([])
  const [gTotal9BCL, setGTotal9BCL] = useState([])

  const [total7PS, setTotal7PS] = useState([])
  const [total8PS, setTotal8PS] = useState([])
  const [total9PS, setTotal9PS] = useState([])
  const [gTotal7APS, setGTotal7APS] = useState([])
  const [gTotal7BPS, setGTotal7BPS] = useState([])
  const [gTotal8PS, setGTotal8PS] = useState([])
  const [gTotal9APS, setGTotal9APS] = useState([])
  const [gTotal9BPS, setGTotal9BPS] = useState([])

  const reloadTotalMarkers = async () => {
    const [
      total,
      totalCategory,
      totalCompany,
      gATotalCompany,
      gBTotalCompany,
      gTotal,
      gACategory,
      gBCategory,
      totalCommercial,
      totalCommercial5,
      totalCommercial6,
      totalCommercial4A,
      totalCommercial4B,
      totalCommercial5GB,
      totalCommercial6A,
      totalCommercial6B,
    ] = await Promise.all([
      boardReportsService.getTotalMarket4W('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket4W('2', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket4W('3', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4W('1a', selectedDate.getFullYear(), 'limite=15'),
      boardReportsService.getGTotalMarket4W('1b', selectedDate.getFullYear(), 'limite=10'),
      boardReportsService.getGTotalMarket4W('2', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4W('3a', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket4W('3b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket4W('4', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
      boardReportsService.getTotalMarket4W('5', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
      boardReportsService.getTotalMarket4W('6', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
      boardReportsService.getGTotalMarket4W('4a', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&limite=15'),
      boardReportsService.getGTotalMarket4W('4b', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&limite=10'),
      boardReportsService.getGTotalMarket4W('5', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
      boardReportsService.getGTotalMarket4W('6a', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
      boardReportsService.getGTotalMarket4W('6b', selectedDate.getFullYear(), 'subcategoria=COMERCIAL'),
    ])
    setTotals(total)
    setTotalCategory(totalCategory)
    setTotalCompany(totalCompany)
    setGATotalCompany(gATotalCompany)
    setGBTotalCompany(gBTotalCompany)
    setGTotal(gTotal)
    setGACategory(gACategory)
    setGBCategory(gBCategory)
    setTotalsCommercial(totalCommercial)
    setTotalsCommercial5(totalCommercial5)
    setTotalsCommercial6(totalCommercial6)
    setTotalsCommercial4A(totalCommercial4A)
    setTotalsCommercial4B(totalCommercial4B)
    setTotalsCommercial5GB(totalCommercial5GB || [])
    setTotalsCommercial6A(totalCommercial6A)
    setTotalsCommercial6B(totalCommercial6B)
  }

  const reloadConsume = async () => {
    const [total4P, total5P, total6P, gTotal4AP, gTotal4BP, gTotal5P, gTOTAL6AP, gTOTAL6BP] = await Promise.all([
      boardReportsService.getTotalMarket4W('4', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
      boardReportsService.getTotalMarket4W('5', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
      boardReportsService.getTotalMarket4W('6', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
      boardReportsService.getGTotalMarket4W('4a', selectedDate.getFullYear(), 'subcategoria=PERSONALES&limite=15'),
      boardReportsService.getGTotalMarket4W('4b', selectedDate.getFullYear(), 'subcategoria=PERSONALES&limite=10'),
      boardReportsService.getGTotalMarket4W('5', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
      boardReportsService.getGTotalMarket4W('6a', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
      boardReportsService.getGTotalMarket4W('6b', selectedDate.getFullYear(), 'subcategoria=PERSONALES'),
    ])
    setTotal4P(total4P)
    setTotal5P(total5P)
    setTotal6P(total6P)
    setTotalG4AP(gTotal4AP)
    setTotalG4BP(gTotal4BP)
    setGTotal5P(gTotal5P || [])
    setGTotal6AP(gTOTAL6AP)
    setGTotal6BP(gTOTAL6BP)
  }

  const reloadCommercialLoad = async () => {
    const [
      total7CL = [],
      total8CL = [],
      total9CL = [],
      gTotal7ACL = [],
      gTotal7BCL = [],
      gTotal8CL = [],
      gTotal9ACL = [],
      gTotal9BCL = [],
    ] = await Promise.all([
      boardReportsService.getTotalMarket4W('7', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
      boardReportsService.getTotalMarket4W('8', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
      boardReportsService.getTotalMarket4W('9', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
      boardReportsService.getGTotalMarket4W(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&limite=10&segmento=CARGA'
      ),
      boardReportsService.getGTotalMarket4W(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&limite=10&segmento=CARGA'
      ),
      boardReportsService.getGTotalMarket4W('8', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
      boardReportsService.getGTotalMarket4W('9a', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
      boardReportsService.getGTotalMarket4W('9b', selectedDate.getFullYear(), 'subcategoria=COMERCIAL&segmento=CARGA'),
    ])
    setTotal7CL(total7CL)
    setTotal8CL(total8CL)
    setTotal9CL(total9CL)
    setGTotal7ACL(gTotal7ACL)
    setGTotal7BCL(gTotal7BCL)
    setGTotal8CL(gTotal8CL)
    setGTotal9ACL(gTotal9ACL)
    setGTotal9BCL(gTotal9BCL)
  }

  const reloadCommercialPassengers = async () => {
    const [
      total7PS = [],
      total8PS = [],
      total9PS = [],
      gTotal7APS = [],
      gTotal7BPS = [],
      gTotal8PS = [],
      gTotal9APS = [],
      gTotal9BPS = [],
    ] = await Promise.all([
      boardReportsService.getTotalMarket4W(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
      boardReportsService.getTotalMarket4W(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
      boardReportsService.getTotalMarket4W(
        '9',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
      boardReportsService.getGTotalMarket4W(
        '7a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&limite=10&segmento=PASAJEROS'
      ),
      boardReportsService.getGTotalMarket4W(
        '7b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&limite=10&segmento=PASAJEROS'
      ),
      boardReportsService.getGTotalMarket4W(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
      boardReportsService.getGTotalMarket4W(
        '9a',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
      boardReportsService.getGTotalMarket4W(
        '9b',
        selectedDate.getFullYear(),
        'subcategoria=COMERCIAL&segmento=PASAJEROS'
      ),
    ])
    setTotal7PS(total7PS)
    setTotal8PS(total8PS)
    setTotal9PS(total9PS)
    setGTotal7APS(gTotal7APS)
    setGTotal7BPS(gTotal7BPS)
    setGTotal8PS(gTotal8PS)
    setGTotal9APS(gTotal9APS)
    setGTotal9BPS(gTotal9BPS)
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadCommercialPassengers()
    reloadCommercialLoad()
    reloadTotalMarkers()
    reloadConsume()
  }, [selectedDate])

  return (
    <Total4WMarketPage
      total7PS={total7PS}
      total8PS={total8PS}
      total9PS={total9PS}
      gTotal7APS={gTotal7APS}
      gTotal7BPS={gTotal7BPS}
      gTotal8PS={gTotal8PS}
      gTotal9APS={gTotal9APS}
      gTotal9BPS={gTotal9BPS}
      total={total}
      gTotal={gTotal}
      total4P={total4P}
      total5P={total5P}
      total6P={total6P}
      gTotal4AP={gTotal4AP}
      gTotal4BP={gTotal4BP}
      gTotal5P={gTotal5P}
      gTOTAL6AP={gTOTAL6AP}
      gTOTAL6BP={gTOTAL6BP}
      total7CL={total7CL}
      total8CL={total8CL}
      total9CL={total9CL}
      gTotal7ACL={gTotal7ACL}
      gTotal7BCL={gTotal7BCL}
      gTotal8CL={gTotal8CL}
      gTotal9ACL={gTotal9ACL}
      gTotal9BCL={gTotal9BCL}
      totalCommercial6A={totalCommercial6A}
      totalCommercial6B={totalCommercial6B}
      totalCommercial5={totalCommercial5}
      totalCommercial6={totalCommercial6}
      totalCommercial4A={totalCommercial4A}
      totalCommercial4B={totalCommercial4B}
      totalCommercial5GB={totalCommercial5GB}
      totalCommercial={totalCommercial}
      gACategory={gACategory}
      gBCategory={gBCategory}
      totalCategory={totalCategory}
      totalCompany={totalCompany}
      gATotalCompany={gATotalCompany}
      gBTotalCompany={gBTotalCompany}
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
    />
  )
}

export default Total4WMarketContainer
